import { render, staticRenderFns } from "./CatalogsMenu.vue?vue&type=template&id=ac158736"
import script from "./CatalogsMenu.vue?vue&type=script&lang=js"
export * from "./CatalogsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports